package com.pincer.client

import com.pincer.core.Logger
import kotlinx.coroutines.delay

typealias WebSocketListener = (String) -> Boolean

class WebSocket(private val url: String, private val jobCentre: JobCentre, private val log: Logger) {

    private val socket = MpWebSocket(url = "$url/v1", log = log, callback = this::sendToListeners)

    private val justOnceListeners = mutableListOf<WebSocketListener>()
    private val permanentListeners = mutableListOf<WebSocketListener>()

    suspend fun start() {
        log.i("WebSocket starting")
        /*
        Would be neat to do this here, but we need full jwt powered principal
        log.i("Starting principalWhoAmI loop")
        jobCentre.launch("principalWhoAmIs") {
            while (true) {
                //log.f("principalWhoAmI")
                message("ping")
                delay(20*1000)
            }
        }
        */
    }

    suspend fun stop() {
        socket.close()
        log.i("WebSocket stopped")
    }

    fun message(string: String) = socket.send(string)

    suspend fun registerListener(permanent: Boolean, listener: WebSocketListener) {
        if (permanent) {
            permanentListeners.add(listener)
        } else {
            justOnceListeners.add(listener)
        }
    }

    private suspend fun sendToListeners(string: String) {
        if (string == "pong") return
        val iterator = justOnceListeners.iterator()
        while (iterator.hasNext()) {
            val listener = iterator.next()
            if (listener(string)) {
                iterator.remove()
                return
            }
        }
        var someoneListened = false
        for (listener in permanentListeners) {
            if (listener(string)) someoneListened = true
        }
        if (!someoneListened) {
            log.w("No one listened to string: $string")
            log.i(string)
        }
    }

}
